/**
 * Field names of a failed validation. PHP 7 sends "field type error: a, b" as
 * text, the PHP 8 backend { message: 'field type error', fields: ['a', 'b'] }.
 * Returns null when the error is no validation error.
 */
export function fieldTypeErrors(error: unknown): string[] | null {
    const result = (error as any)?.error?.result ?? (error as any)?.result;
    if (typeof result === 'string') {
        if (!result.includes('field type error')) {
            return null;
        }
        return result
            .replace(/^.*field type error:?/, '')
            .split(',')
            .map(field => field.trim())
            .filter(Boolean);
    }
    if (
        result &&
        typeof result === 'object' &&
        String(result.message ?? '').includes('field type error')
    ) {
        const fields = result.fields ?? result.errors ?? [];
        const list = Array.isArray(fields) ? fields : Object.keys(fields);
        return list.map(field => String(field).trim()).filter(Boolean);
    }
    return null;
}

/** Error text of a failed request, for the PHP 7 string and the PHP 8 object result. */
export function apiErrorText(error: unknown): string {
    const result = (error as any)?.error?.result ?? (error as any)?.result;
    if (typeof result === 'string') {
        return result;
    }
    return [result?.code, result?.message].filter(Boolean).join(' ');
}
